<script lang="ts" setup>
import {AppButton, AppTypography} from "~/components/base";

const {
  icon = null,
  title = '',
  description = '',
  btnText = 'Close',
  btnVariant = 'flat',
  btnColor = 'yellow-darken-1',
  cancelBtn = false,
  cancelBtnText = 'Cancel',
  loading = false,
  width = 391,
} = defineProps<{
  icon?: string;
  title?: string;
  description?: string;
  btnText?: string;
  btnVariant?: string;
  btnColor?: string;
  cancelBtn?: boolean;
  cancelBtnText?: string;
  loading?: boolean;
  width?: number
}>()

const dialog = defineModel<boolean>()

const emits = defineEmits<{
  (e: 'button-action'): void
  (e: 'close-action'): void
  (e: 'cancel-action'): void
}>()

</script>

<template>
  <v-dialog
      :width="width"
      v-model="dialog"
      persistent>
    <template v-slot:default="{ isActive }">
      <div class="d-flex flex-column dialog-card pa-6">
        <div class="d-flex justify-end">
          <AppButton
              class="border-thin"
              size="small"
              rounded="xl"
              variant="text"
              color="gray"
              icon="mdi mdi-close"
              type="button"
              @click="emits('close-action'); isActive.value = false"
          />
        </div>
        <div class="d-flex flex-column align-center">
          <v-img v-if="icon" :src="icon" width="56" height="56"/>
          <AppTypography element="h4" type="title-4" class="mt-2 text-center">{{ title }}</AppTypography>
          <AppTypography element="p" type="body-1" class="mt-2 text-center" v-html="description"></AppTypography>

          <div class="d-flex flex-column ga-3 mt-6 w-100">
            <div class="flex w-100">
              <AppButton
                  :color="btnColor"
                  :variant="btnVariant"
                  @click="emits('button-action');"
                  block
                  :loading='loading'
              >
                {{ btnText }}
              </AppButton>
            </div>

            <div class="flex w-100" v-if="cancelBtn">
              <AppButton color="" variant="outlined" block @click="isActive.value = false" :disabled="loading">
                {{ cancelBtnText }}
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </template>
  </v-dialog>
</template>

<style scoped lang="scss">

</style>